import { AccountType } from "@/api/generated/graphql";

export const nonCashAccountTypes = [AccountType.Loan, AccountType.Investment];
